import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Tooltip } from '@myua/kit';
import { Wifi } from '@myua/icons/dist/linear16';
import { getHeaderMenuTriggers, isHeaderLoaded, onHeaderLoaded } from '../Header/initHeader';
import { SLOW_NETWORK_MESSAGE } from '../../slowNetwork';
import './styles.scss';

// Индикатор нестабильной сети в зоне шапки: оранжевая иконка wifi с тултипом.
// Появляется вместе с предупреждением о медленном соединении и остаётся, пока
// перепроверки скорости не подтвердят восстановление (MYUA-16416).
//
// Один компонент на все сервисы (Creative Hub, Asset Lab): шапка общая, разметка
// одинаковая, а тултип — antd-компонент кита, который работает в обоих
// приложениях. Признак `slow` приходит пропом, потому что стор у каждого сервиса
// свой — это единственное, что различается.
//
// Шапка — внешний aa-header, поэтому иконка монтируется порталом в её контейнер
// иконок-триггеров: встаёт в общий grid рядом с остальными и живёт в stacking
// context шапки (собственный fixed-элемент с большим z-index перекрывал бы
// модалки и лайтбоксы приложения — у .aa-header всего z-index: 1).
export const SlowNetworkBadge = ({ slow }: { slow: boolean }) => {
  const [headerLoaded, setHeaderLoaded] = useState(isHeaderLoaded);

  useEffect(() => onHeaderLoaded(() => setHeaderLoaded(true)), []);

  if (!slow || !headerLoaded) {
    return null;
  }

  const host = getHeaderMenuTriggers();
  if (!host) {
    return null;
  }

  // placement bottomRight: у верхней кромки окна тултип над иконкой не помещается.
  return createPortal(
    <Tooltip title={SLOW_NETWORK_MESSAGE} placement="bottomRight">
      <span className="gen-slow-network-badge">
        <Wifi />
      </span>
    </Tooltip>,
    host,
  );
};
